import React, { FC, memo } from 'react';
import classes from './practiceCarousel.module.css';
import joy_girl from 'static/materials/joy_girl.png';
import watchMenu from 'static/materials/watchMenu.png';

export const SixthView: FC = memo(() => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '20%' }}>
          <img src={joy_girl} alt="" width="60%"></img>
        </div>
        <div style={{ width: '80%' }}>
          <div className={classes.yellowBorder}>ステップ1. 練習する！</div>
        </div>
      </div>
      <div style={{ marginTop: '16px' }}>
        <img src={watchMenu} alt="" width="82%"></img>
      </div>
    </>
  );
});
